import React from 'react';
import CreditCard from "./Components/CreditCard";
import './App.css';

function App() {
  return (
    <CreditCard />
  );
}

export default App;
